import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 3v2","key":"svg-0"}],["path",{"d":"M12 3v2","key":"svg-1"}],["path",{"d":"M16 3v2","key":"svg-2"}],["path",{"d":"M9 12v6a3 3 0 0 0 6 0v-6h-6","key":"svg-3"}],["path",{"d":"M8 5h8l-1 4h-6l-1 -4","key":"svg-4"}],["path",{"d":"M12 17v1","key":"svg-5"}]]

const IconRazorElectric = createReactComponent('outline', 'razor-electric', 'RazorElectric', __iconNode);

export default IconRazorElectric;